import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Paper,
    Divider
} from '@mui/material';
import {
    Preview as PreviewIcon,
    Code as CodeIcon
} from '@mui/icons-material';

const PromptPreviewModal = ({ open, onClose, promptContent, expressionName }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="md" 
            fullWidth
            PaperProps={{ sx: { maxHeight: '80vh' } }}
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PreviewIcon sx={{ mr: 2 }} />
                    Generated Prompt Preview
                    {expressionName && (
                        <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
                            for "{expressionName}"
                        </Typography>
                    )}
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary" paragraph>
                        This is how your identity expression will be converted to instructions for the AI agent.
                        The psychological scales and factor values are transformed into natural language that
                        defines the agent's behavioral characteristics.
                    </Typography>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Paper 
                    sx={{ 
                        p: 2, 
                        bgcolor: 'grey.50',
                        border: '1px solid',
                        borderColor: 'grey.300',
                        maxHeight: '60vh',
                        overflow: 'auto'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <CodeIcon sx={{ mr: 1, color: 'text.secondary' }} />
                        <Typography variant="subtitle2" color="text.secondary">
                            Agent Identity Prompt
                        </Typography>
                    </Box>
                    
                    <Typography 
                        variant="body2" 
                        component="pre"
                        sx={{ 
                            fontFamily: 'monospace',
                            fontSize: '0.875rem',
                            lineHeight: 1.6,
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            margin: 0
                        }}
                    >
                        {promptContent}
                    </Typography>
                </Paper>

                <Box sx={{ mt: 2 }}>
                    <Typography variant="caption" color="text.secondary">
                        <strong>Note:</strong> This prompt will be used to define the agent's personality and 
                        behavioral patterns in conversations and tasks. Make sure it accurately reflects 
                        your intended psychological profile.
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Close
                </Button>
                <Button 
                    variant="outlined"
                    onClick={() => {
                        navigator.clipboard.writeText(promptContent);
                        // Could add a toast notification here
                    }}
                >
                    Copy to Clipboard
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PromptPreviewModal;
